import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { PisDepositStatusChip } from './PisDepositStatusChip'

const LEGEND: { status: string; text: string }[] = [
  {
    status: 'RECEIVED',
    text: 'Just initiated at the bank — signing (BankID/MitID) not completed yet.',
  },
  {
    status: 'PENDING',
    text: 'Waiting at the bank — see the Reason column. Usually the payer hasn’t finished signing, an additional signatory must approve, or the payment needs approval in the payer’s online bank.',
  },
  {
    status: 'ACCEPTED',
    text: 'Accepted by the bank for execution — not necessarily on the Mynt account yet. The transfer settles via normal bank rails, typically the same or next banking day, and is booked as a top-up when it arrives. Escalate if it hasn’t arrived after a couple of banking days.',
  },
  {
    status: 'REJECTED',
    text: 'Declined by the bank, e.g. insufficient funds or account restrictions. No money moved.',
  },
  {
    status: 'FAILED',
    text: 'Signing never completed — abandoned, BankID order expired, a competing session, or missing payment rights. No money moved; the customer can simply try again.',
  },
  {
    status: 'CANCELLED',
    text: 'Cancelled before execution, by support or at the bank. No money moved.',
  },
]

export const PisDepositStatusLegend = () => (
  <Accordion disableGutters elevation={0} sx={{ border: '1px solid', borderColor: 'divider', '&:before': { display: 'none' } }}>
    <AccordionSummary expandIcon={<ExpandMoreIcon fontSize="small" />} sx={{ minHeight: 40, '& .MuiAccordionSummary-content': { my: 1 } }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <InfoOutlinedIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
        <Typography sx={{ fontSize: 13, fontWeight: 600 }}>Status guide</Typography>
      </Box>
    </AccordionSummary>
    <AccordionDetails sx={{ pt: 0 }}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'auto 1fr',
          columnGap: 2.5,
          rowGap: 1.25,
          alignItems: 'start',
          maxWidth: 860,
        }}
      >
        {LEGEND.map(({ status, text }) => (
          <Box key={status} sx={{ display: 'contents' }}>
            <PisDepositStatusChip status={status} />
            <Typography sx={{ fontSize: 13, lineHeight: 1.55, color: 'text.secondary' }}>{text}</Typography>
          </Box>
        ))}
      </Box>
      <Typography sx={{ fontSize: 12, lineHeight: 1.5, color: 'text.disabled', mt: 2, maxWidth: 860 }}>
        A deposit stuck in RECEIVED or PENDING can be re-checked with “Check live status at bank” in the row’s detail view — this also
        corrects the stored status if the bank disagrees.
      </Typography>
    </AccordionDetails>
  </Accordion>
)
